<template>
	<div class="meeting-index">
		<van-pull-refresh v-model="loading.pullRefresh" @refresh="pullRefresh"  success-text="刷新成功">
			<div class="header">
<!-- 				<div class="swiper-img">
					<van-swipe :autoplay="3000" indicator-color="white">
					  <van-swipe-item v-for="(item,index) in swiperImg" :key="index">
					  		<img :src="item.banner" alt="">
					  </van-swipe-item>
					</van-swipe>
				</div> -->
				<banner :type="type"></banner>
				<div class="operations">
					<router-link class="operation-item" to="/meeting/calendar">
						<img src="../../assets/images/Meeting/Meeting_calendar.png" alt="">
						<span>会议日历</span>
					</router-link>
					<span class="line"></span>
					<!-- <router-link class="operation-item" :to="{path:'/expert/search',query:{name:'expert'}}"> -->
					<router-link class="operation-item" :to="{path:'/vascularNews/expert/all'}">
						<img src="../../assets/images/Meeting/Meeting_expert.png" alt="">
						<span>专家查询</span>
					</router-link>
				</div>
			</div>
			<div class="hr-7"></div>
			<div class="content">
				<van-tabs v-model="active" sticky title-inactive-color="#999" title-active-color="#090909" color="#901d22">
				  <van-tab  title="近期会议">
					<div class="meetingList">
						<van-list
							  v-model="loading.recentPullUp"
							  :finished="finished.recent"
							  finished-text="没有更多了"
							  @load="pullUpLoading"
							  class="van-clearfix"
							  :immediate-check="isCheck"
							>
							<template v-for="item in recentMeetings">
								<item-block :itemContent="item" ></item-block>
							</template>
						</van-list>
					</div>
				  </van-tab>
				  <van-tab  title="历史会议">
				  	<div class="meetingList">
						<van-list
							  v-model="loading.historyPullUp"
							  :finished="finished.history"
							  finished-text="没有更多了"
							  @load="pullUpLoading"
							  class="van-clearfix"
							  :immediate-check="isCheck"
							>
							<template v-for="item in historyMeetings">
								<item-block :itemContent="item" ></item-block>
							</template>
						</van-list>				  		
				  	</div>
				  </van-tab>
				</van-tabs>
			</div>
		</van-pull-refresh>
		<tabbar :active="index"></tabbar>
	</div>
</template>
<script>
	import ItemBlock from '../../components/ItemBlock';
	import Tabbar from '../../components/Tabbar'
	import Banner from "../../components/Banner"
	import {MeetingRecent,MeetingHistory,ModulesRecommend} from '../../config/interface.js'
	export default{
		components:{
			ItemBlock,
			Tabbar,
			Banner
		},
		data(){
			return{
				type:2,		//1:专栏模块; 2:会议模块; 3:前沿资讯模块;4:病例模块;5:器械模块; 6:首页;7:文章推荐
				index:1,    //tabbar的index值
				isCheck:false,
				active:0,
				value:0,
				recentLimit:5,    
				recentPage:1,
				recentMeetings:[],    //近期会议
				historyLimit:5,    
				historyPage:1,				
				historyMeetings:[],   //历史会议
				loading:{
					pullRefresh:false,
					recentPullUp:false,
					historyPullUp:false
				},
				swiperImg:[],
				finished:{
					recent:false,
					history:false
				}
			}
		},
		mounted(){
			this.GetRecentMeetings();
			this.GetHistoryMeetings();
			this.getSwiperImg();
			if(common.is_weixin()){
				common.wxShare("【血管资讯】学术会议日历",'血管外科领域线上学术会议日历，欢迎点击查询及联系会议信息公布','cdn.edstatic.com/203012120000/bca5bbcde6b65142646518943d71936a/2020/09/8e44215d-f687-4be7-8ced-81c3c880587a.png');
			}
		},
		methods:{
			//轮播图
			getSwiperImg(){
				this.$store.dispatch('isShowLoading',true);
				const url=ModulesRecommend;
				const method='POST';
				let params={
					module_id:2   //1为专栏  2为会议
				}
				fetch(url,params,method)
				.then((res)=>{
					if(res.code==0){
						let data=res.data;
						this.swiperImg=data;
					}
					this.$store.dispatch('isShowLoading',false);
				})
			},
			//下拉刷新
			pullRefresh(){
				setTimeout(() => {
			        this.loading.pullRefresh = false;
			        this.recentMeetings=[];
			        this.historyMeetings=[];
			        this.recentPage=1;
			        this.historyPage=1;
			        this.finished.recent=false;
			        this.finished.history=false;
					this.GetRecentMeetings();
					this.GetHistoryMeetings();
			      }, 1000);
			},
			//上拉加载
			pullUpLoading(){
			    setTimeout(() => {
			    	this.active==0?this.recentPage++:this.historyPage++;
			        this.active==0?this.GetRecentMeetings():this.GetHistoryMeetings();
			      }, 500);
			},
			//近期会议
			GetRecentMeetings(){
				const url=MeetingRecent;
				const method='POST'
				let params={
					limit:this.recentLimit,
					page:this.recentPage
				}
				fetch(url,params,method)
				.then((res)=>{
					if(res.code==0){
						let data=res.data.data;
						data.forEach((item,index)=>{
							item.start_at=((item.start_at.split(' ')[0]).split('-')).join('.');
							let end_at_arr=(item.end_at.split(' ')[0]).split('-');
							item.end_at=end_at_arr[1]+'.'+end_at_arr[2];
							this.recentMeetings.push(item);
						})
       					this.loading.recentPullUp = false;
						if(res.data.data.length<this.recentLimit){
							this.finished.recent=true;
						}
						this.$store.dispatch('isShowLoading',false);
						
					}
				})
			},
			meetingPassword(){

			},
			//历史会议
			GetHistoryMeetings(){
				const url=MeetingHistory;
				const method='POST'
				let params={
					limit:this.historyLimit,
					page:this.historyPage
				}
				fetch(url,params,method)
				.then((res)=>{
					if(res.code==0){
						let data=res.data.data;
						data.forEach((item,index)=>{
							item.start_at=((item.start_at.split(' ')[0]).split('-')).join('.');
							let end_at_arr=(item.end_at.split(' ')[0]).split('-');
							item.end_at=end_at_arr[1]+'.'+end_at_arr[2];
							this.historyMeetings.push(item);
						})
       					this.loading.historyPullUp = false;
						if(res.data.data.length<this.historyLimit){
							this.finished.history=true;
						}
						
					}
				})				
			}
		}
	}
</script>
<style lang="scss">
	.meeting-index{
		.header{
			.swiper-img{
				padding:14px 12px;
				img{
					width:100%;
					height:150px;
					border-radius:5px;

				}
			}
			.operations{
				margin-bottom:10px;
				@include flex(row);
				align-items:center;
				justify-content:space-around;
				.operation-item{
					padding:0 5px;
					@include flex(row);
					align-items:center;
					img{
						height:38px;
					}
					span{
						min-width:60px;
						font-size:14px;
						color:$color-black;
						margin-left:5px;
					}
				}
				span.line{
					display:block;
					width:1px;
					height:20px;
					background:#cbcbcb;
				}
			}
		}
		.content{
			margin-bottom:50px;
			.van-tab{
				flex:initial;
				width:25%;
			}
			.meetingList{
				padding:0px 12px;
				.item-block:last-child{
					border:0px;
				}
			}
		}
	}
</style>


// WEBPACK FOOTER //
// src/pages/Meeting/index.vue